import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	BadgeComponent,
	ButtonIconComponent,
	Icons,
	InfoGroupComponent,
	ItemComponent,
	ListDetailComponent,
	TagComponent,
	TagIconComponent,
} from '@tecalisdev/infinity';
import { DocStatus, IOperationDocument } from '../../../../../processes/models/processes.models';
import { MasterService } from '../../../../services/master.service';

/**
 * Fila de documento en detalle (ops + process): icono, título, estado, modo, intentos, eye.
 */
@Component({
	selector: 'app-operation-document-list-item',
	imports: [
		TranslatePipe,
		ItemComponent,
		TagComponent,
		ListDetailComponent,
		InfoGroupComponent,
		BadgeComponent,
		TagIconComponent,
		ButtonIconComponent,
	],
	templateUrl: './operation-document-list-item.component.html',
	styleUrl: './operation-document-list-item.component.scss',
})
export class OperationDocumentListItemComponent {
	@Input({ required: true }) doc!: IOperationDocument;
	@Output() open = new EventEmitter<string>();

	public masterService = inject(MasterService);
	public DocStatus = DocStatus;

	public get titleKey(): string {
		return this.doc?.name || `DOCS.${this.doc?.type ?? ''}`;
	}

	public get documentIcon(): Icons | null {
		return resolveDocumentTypeIcon(this.doc?.type);
	}

	public onOpen(): void {
		const url = this.doc?.url;
		if (url) this.open.emit(url);
	}
}

const DOCUMENT_TYPE_ICONS: Record<string, Icons> = {
	DRIVE_LICENSE: 'icon-card',
	DNI: 'icon-card',
	PASSPORT: 'icon-card',
	NIE: 'icon-card',
	CERT_REG_CIU_UE: 'icon-card',
	IRPF: 'icon-euro',
	CHECK: 'icon-euro',
	INVOICE: 'icon-euro',
	WORKLIFE: 'icon-briefcase',
	PAYROLL: 'icon-briefcase',
	SCRIPTURE: 'icon-briefcase',
	GENERIC: 'icon-book-open',
};

export function resolveDocumentTypeIcon(type?: string | null): Icons | null {
	if (!type) return null;
	return DOCUMENT_TYPE_ICONS[type] ?? null;
}
